import { render } from "./product-description.vue?vue&type=template&id=d4dec808"
import script from "./product-description.vue?vue&type=script&lang=js"
export * from "./product-description.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__